<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <div class="d-flex justify-content-between" style="width: 90%">
          <h2 class="mt-5">{{$t('message.Test_results')}}</h2>
<!--          <a v-if="application" :href="$backendHost+'/'+application.objective" target="_blank" class="text-white">-->
            <b-button class="eye-button w-auto" @click="applicationModal=true">
              {{$t('message.Objective')}}
              <i class="bx bx-show-alt font-size-18"></i>
            </b-button>
<!--          </a>-->
          <div v-if="application && tests.length">
            <div class="d-flex" v-if="application.cur_status.status_name !== 'accepted' && application.cur_status.status_name !== 'rejected'">
              <div>
                <b-button size="sm" @click="challangeClick" variant="primary" class="mt-5">
                  {{$t('message.AcceptToWork')}}
                </b-button>
              </div>
              <div>
                <b-button size="sm" @click="rejectClick" variant="warning" class="mt-5 ms-1">
                  {{$t('message.Reject')}}
                </b-button>
              </div>
            </div>
            <div v-else class="mt-5">
              <div class="badge rounded-pill bg-info font-size-14">{{application.cur_status.name}}</div>
            </div>
          </div>
        </div>
        <div>
          <b-card class="card" style="margin: 0 auto; width: 90%">
            <b-table
                responsive
                striped
                hover
                :items="tests"
                :fields="fields">
              <template #cell(action)="data">
                <div class="d-flex">
                  <b-button
                      @click="$router.push({name: 'TestAnswers', params: {testId: data.item.id}})"
                      style="background-color: #185d89"
                      variant="primary"
                      v-if="data.item.checked_answers"
                      size="md">
                    <i class="bx bx-show-alt font-size-18"></i>
                  </b-button>
                  <div v-if="data.item.test_status.status_name === 'new' || data.item.test_status.status_name === 'finished'" class="d-flex">
                    <b-button
                        v-if="data.item.checked_answers"
                        class="d-inline ms-1"
                        variant="outline-primary"
                        size="xs"
                        @click="approveTestResult(data.item)" >{{$t('message.Confirm')}}</b-button>
                    <b-button
                        v-if="data.item.checked_answers"
                        class="d-inline ms-1"
                        variant="outline-primary"
                        size="xs"
                        @click="rejectTestResult(data.item)">{{$t('message.Not_confirmed')}}</b-button>
                  </div>
                </div>
              </template>
            </b-table>
          </b-card>
        </div>
      </div>
    </div>
    <b-modal id="modal-1" hide-footer size="md" v-model="denyModal">
      <DenyApplication :testStatus="testStatus" @closeDenyForm="closeDenyForm" />
    </b-modal>
    <b-modal v-model="applicationModal" hide-footer size="lg">
      <b-row v-if="activeApplication">
        <b-col md="6">
          <div class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.FullName')}}</h5>
            <p>{{activeApplication.fio}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Category')}}</h5>
            <p>{{activeApplication.category ? activeApplication.category.name : ''}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Education')}}</h5>
            <p>{{activeApplication.education ? activeApplication.education.name : ''}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Experience')}}</h5>
            <p>{{activeApplication.experience ? activeApplication.experience.name : ''}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Work_experience')}}</h5>
            <p v-for="(exp, expIndex) in activeApplication.working_experiences" :key="expIndex">
              {{exp.experience ? exp.experience.name : ''}} - {{exp.year}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Mobile_number')}}</h5>
            <p>{{activeApplication.mobile}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Address')}}</h5>
            <p>{{activeApplication.address}}</p>
          </div>
        </b-col>
        <b-col md="6">
          <div class="w-100 border-bottom">
            <h5>{{$t('message.LanguageLevel')}}</h5>
            <div v-if="activeApplication.language_levels">
              <div class="w-100 my-1" v-for="(lang, langIndex) in activeApplication.language_levels" :key="langIndex">
                {{lang.language.name}} - {{lang.level.name}}
              </div>
            </div>
          </div>
          <div v-if="activeApplication.objective !== 'null'" class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Objective')}}</h5>
            <a :href="$backendHost+activeApplication.objective" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 border-bottom" v-if="activeApplication.government_reward !== 'null'">
            <h5 class="font-weight-semibold">{{$t('message.Government_reward')}}</h5>
            <a :href="$backendHost+activeApplication.government_reward" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 border-bottom" v-if="activeApplication.other_reward !== 'null'">
            <h5 class="font-weight-semibold">{{$t('message.Other_reward')}}</h5>
            <a :href="$backendHost+activeApplication.other_reward" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 border-bottom" v-if="activeApplication.workable_document !== 'null'">
            <h5 class="font-weight-semibold">{{$t('message.Entitling')}}</h5>
            <a :href="$backendHost+activeApplication.workable_document" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.PINFL')}}</h5>
            <p>{{activeApplication.pinfl}}</p>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>

import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getApplicationTests, changeTestStatus} from "../../../../../../api/tests";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";
import Swal from "sweetalert2";
import DenyApplication from "../jobs/denying/DenyApplication";
import { updateApplicationStatus} from "../../../../../../api/school-vacany-applications";


export default {
  name: "TestResultAction",
  components: {
    HorizontalTopbarInside,
    SideBar,
    DenyApplication,
  },
  data() {
    return {
      isMenuCondensed: false,
      denyModal: false,
      applicationModal:false,
      activeApplication: null,
      testStatus: {
        status: null,
        application_id: null,
      },
      fields: [
        {
          key: "id",
          label: "ID"
        },
        {
          key: "test.title",
          label: this.$t('message.Title')
        },
        {
          key:"correct_answers",
          label: this.$t('message.CorrectAnswers')
        },
        {
          key:"wrong_answers",
          label: this.$t('message.WrongAnswers')
        },
        {
          key:"test.time",
          label: this.$t('message.Time')
        },
        {
          key: "test_status.name",
          label: this.$t('message.Status')
        },
        {
          key: "action",
          label: this.$t('message.Action')
        },
      ],
      tests: [],
      application: null,
    };
  },
  computed: {
    ...layoutComputed,
  },
  created() {
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.getTests()
  },
  methods: {
    getTests() {
      getApplicationTests({application_id: this.$route.params.id}).then(res => {
        this.tests = res.data.data;
        this.application = res.data.application;
        this.activeApplication = res.data.application;
        this.activeApplication.fio = this.activeApplication.last_name +' ' + this.activeApplication.first_name + ' ' + this.activeApplication.middle_name;
      })
    },
    challangeClick() {
      this.testStatus.application_id = this.$route.params.id;
      this.testStatus.status = 4;

      Swal.fire({
        title: this.$t('message.DoYouWantAccept'),
        text: this.$t('message.Not_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.Allow"),
        cancelButtonText: this.$t('message.Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-unused-vars
          updateApplicationStatus(this.testStatus).then(res => {
            Swal.fire({
              icon: 'success',
              position: 'center',
              title: this.$t('message.HasAllowed'),
              text: this.$t('message.Allowed'),
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.getTests()
          })
        } else if (result.dismiss === 'cancel') {
          Swal.fire({
            title: this.$t('message.Cancelled'),
            text: this.$t('message.NotAllowed'),
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })

    },
    rejectClick() {
      this.testStatus.application_id = this.$route.params.id;
      this.testStatus.status = 3;
      Swal.fire({
        title: this.$t('message.DoYouWantReject'),
        text: this.$t('message.Not_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t("message.Reject"),
        cancelButtonText: this.$t('message.Cancel'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-unused-vars
          updateApplicationStatus(this.testStatus).then(res => {
            Swal.fire({
              icon: 'success',
              position: 'center',
              title: this.$t('message.Rejected'),
              text: this.$t('message.Rejected'),
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.getTests()
          })
        } else if (result.dismiss === 'cancel') {
          Swal.fire({
            title: this.$t('message.Cancelled'),
            text: this.$t('message.NotAllowed'),
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    closeDenyForm() {
      this.getTests()
    },
    approveTestResult(data) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-unused-vars
          changeTestStatus({ id:data.id, status_name: 'accepted' }).then(res => {
            this.$swal({
              icon: 'success',
              position: 'center',
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.getTests()
          })
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    rejectTestResult(data) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // eslint-disable-next-line no-unused-vars
          changeTestStatus({ id:data.id,status_name:'rejected' }).then(res => {
            this.$swal({
              icon: 'success',
              position: 'center',
              title: 'Deleted!',
              text: 'Your file has been deleted.',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.getTests()
          })
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            text: 'Your imaginary file is safe :)',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.eye-button{
  height: 30px;
  width: 50px;
  margin-top: 50px;
  padding: 0;
}
</style>



